import { log } from "../../log";
import { CallEventType } from "./model";
import { callCreateRequest, clearAllCalls } from "./actions";
import { mqttEvent } from "../actions";
/**
 * Catch all events about a specific call
 * @param callId
 */
export function onlyCallPattern(callId) {
    return (action) => {
        var _a;
        return ((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.callId) === callId ||
            (action === null || action === void 0 ? void 0 : action.type) === clearAllCalls.toString();
    };
}
export function controllerPattern(parent) {
    return (action) => {
        var _a, _b;
        if ([
            // why do we need to match on any mqtt event here?
            mqttEvent.toString(),
            CallEventType.CALL_CREATED,
            callCreateRequest.toString(),
        ].includes(action.type)) {
            if (((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.target) &&
                ((_b = action === null || action === void 0 ? void 0 : action.payload) === null || _b === void 0 ? void 0 : _b.target) !== parent.identity()) {
                log.warn("taskManagerController got controller event for other target");
                return false;
            }
            else {
                return true;
            }
        }
    };
}
//# sourceMappingURL=patterns.js.map